import type * as React from "react"

import { cn } from "@/lib/utils"

export function FormFieldLabel(
  props: React.LabelHTMLAttributes<HTMLLabelElement>,
) {
  return (
    <span
      {...props}
      className={cn(
        "text-sm text-slate-500 whitespace-nowrap",
        props.className,
      )}
    />
  )
}

